import { Crown } from 'lucide-react';

/**
 * Reusable Founding Member badge chip.
 *
 * Renders only when `user?.founder_pioneer === true`. Variants:
 *   - 'full'   → pill with label "Founding Member" (default)
 *   - 'compact' → just the crown icon in a small chip (next to avatar)
 *
 * Color is intentionally gold (#FFD700) on a dark chip so it stands
 * out against both light and dark surfaces without re-theming.
 */
export default function FounderBadge({ user, variant = 'full', className = '' }) {
  if (!user?.founder_pioneer) return null;

  if (variant === 'compact') {
    return (
      <span
        title="Founding Member — 1 of the first 500 pioneers"
        className={`inline-flex items-center justify-center w-5 h-5 rounded-full bg-[#FFD700] text-[#0A0A0A] shadow-sm ${className}`}
        data-testid="founder-badge-compact"
        aria-label="Founding Member"
      >
        <Crown className="w-3 h-3" strokeWidth={2.5} />
      </span>
    );
  }

  return (
    <span
      title="Founding Member — 1 of the first 500 pioneers"
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-[#FFD700]/15 border border-[#FFD700]/40 text-[#FFD700] text-[10px] font-bold uppercase tracking-wider ${className}`}
      data-testid="founder-badge"
    >
      <Crown className="w-3 h-3" strokeWidth={2.5} />
      Founding Member
    </span>
  );
}
